import {
  collection, doc, getDocs, setDoc, deleteDoc,
  serverTimestamp, writeBatch, query, orderBy, limit, getDoc
} from "firebase/firestore";

// ─── Ler coordenadas da coleção ritCoords ────────────────────────────────────
export const getRitCoords = async (db) => {
  try {
    const snap = await getDocs(collection(db, "ritCoords"));
    if (snap.empty) return [];
    return snap.docs.map(d => d.data());
  } catch (e) {
    console.warn("⚠️ Erro ao ler ritCoords:", e.message);
    return [];
  }
};

// ─── Fallback: buscar coords direto da coleção rits ──────────────────────────
export const getRitCoordsFromRits = async (db) => {
  try {
    const snap = await getDocs(
      query(collection(db, "rits"), orderBy("createdAt", "desc"), limit(300))
    );
    const result = [];
    for (const d of snap.docs) {
      const r = d.data();
      const lat = parseFloat(r.latitude);
      const lng = parseFloat(r.longitude);
      // Rejeita NaN, infinito, zero exato e valores absurdos
      if (!isFinite(lat) || !isFinite(lng)) continue;
      if (lat === 0 && lng === 0) continue;
      if (Math.abs(lat) > 90 || Math.abs(lng) > 180) continue;
      result.push({
        ritId: d.id,
        numero: r.numero || "",
        latitude: lat,
        longitude: lng,
        natureza: r.natureza || "",
        municipio: r.municipio || "",
        status: r.status || "pendente",
        unitCode: String(r.unitCode || ""),
      });
    }
    return result;
  } catch (e) {
    console.warn("⚠️ Erro ao buscar coords direto de rits:", e.message);
    return [];
  }
};

// ─── Gravar batch de coordenadas (chunks de 499) ─────────────────────────────
const batchWrite = async (db, items) => {
  const CHUNK = 499;
  for (let i = 0; i < items.length; i += CHUNK) {
    const batch = writeBatch(db);
    for (const item of items.slice(i, i + CHUNK)) {
      batch.set(doc(db, "ritCoords", item.ritId), {
        ...item,
        updatedAt: serverTimestamp(),
      });
    }
    await batch.commit();
  }
};

// ─── Reconstruir ritCoords a partir dos rits existentes ──────────────────────
export const rebuildCoordIndex = async (db) => {
  try {
    console.log("📍 Reconstruindo índice ritCoords...");
    const items = await getRitCoordsFromRits(db);
    if (items.length === 0) {
      console.log("ℹ️ Nenhum RIT com coordenadas válidas encontrado.");
      return 0;
    }
    await batchWrite(db, items);
    console.log(`✅ ritCoords reconstruído: ${items.length} entradas`);
    return items.length;
  } catch (e) {
    console.error("❌ Erro ao reconstruir ritCoords:", e.message);
    return 0;
  }
};

// ─── Adicionar/atualizar coordenada ao criar ou editar RIT ───────────────────
export const upsertRitCoord = async (db, ritId, ritData) => {
  try {
    const lat = parseFloat(ritData.latitude);
    const lng = parseFloat(ritData.longitude);
    if (!isFinite(lat) || !isFinite(lng) || (lat === 0 && lng === 0)) {
      await deleteDoc(doc(db, "ritCoords", ritId));
      return;
    }
    await setDoc(doc(db, "ritCoords", ritId), {
      ritId,
      numero: ritData.numero || "",
      latitude: lat,
      longitude: lng,
      natureza: ritData.natureza || "",
      municipio: ritData.municipio || "",
      status: ritData.status || "pendente",
      unitCode: String(ritData.unitCode || ""),
      updatedAt: serverTimestamp(),
    });
  } catch (e) {
    console.warn("⚠️ Erro ao upsert coordenada:", e.message);
  }
};

// ─── Remover coordenada ao deletar RIT ───────────────────────────────────────
export const deleteRitCoord = async (db, ritId) => {
  try {
    await deleteDoc(doc(db, "ritCoords", ritId));
  } catch (e) {
    console.warn("⚠️ Erro ao remover coordenada:", e.message);
  }
};
